import React from 'react';

import { AnchorStyled } from './Styled';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'text';
  children: string;
  href: string;
  fullWidth?: boolean;
  onClick?: () => void;
}

const Anchor = (props: ButtonProps) => {
  const { fullWidth = false, children, variant, href, onClick } = props;

  return (
    <>
      <AnchorStyled fullWidth={fullWidth} className={variant} href={href} onClick={onClick}>
        {children}
      </AnchorStyled>
    </>
  );
};

Anchor.defaultProps = {
  variant: 'primary',
  children: '',
  href: '',
};

export default Anchor;
export { Anchor };
